<template>
  <div>
    <b-row>
      <b-col
        v-if="loading"
        cols="12"
      >
        <loading-card />
      </b-col>
      <template v-else>
        <b-col
          cols="12"
          md="4"
        >
          <default-card
            title="Satışlar"
            :value="overviews.sales"
            icon="CheckCircleIcon"
            color="success"
          />
        </b-col>
        <b-col
          cols="12"
          md="4"
        >
          <default-card
            title="Bağlantılar"
            :value="overviews.connections"
            icon="LinkIcon"
            color="info"
          />
        </b-col>
        <b-col
          cols="12"
          md="4"
        >
          <default-card
            title="Stoklar"
            :value="overviews.stocks"
            icon="CodesandboxIcon"
            color="warning"
          />
        </b-col>
        <b-col cols="12">
          <mixed-charts
            v-if="overviews.chartData.categories.length"
            :categories-data="overviews.chartData.categories"
            :series-data="overviews.chartData.series"
            :yaxis-data="overviews.chartData.yaxis"
            :title-text="overviews.chartData.chartTitle"
          />
        </b-col>
      </template>
    </b-row>
  </div>
</template>
<script>
import { BRow, BCol } from 'bootstrap-vue'
import LoadingCard from '@/layouts/components/Loading.vue'
import DefaultCard from '@/layouts/components/ReportCards/DefaultCard.vue'
import MixedCharts from '@/layouts/components/ReportCharts/MixedCharts.vue'

export default {
  name: 'I2Sales',
  components: {
    MixedCharts,
    DefaultCard,
    LoadingCard,
    BRow,
    BCol,
  },
  computed: {
    overviews() {
      return this.$store.getters['i2SalesOverviewsReports/overviews']
    },
    loading() {
      return this.$store.getters['i2SalesOverviewsReports/loading']
    },
  },
  created() {
    this.getOverviews()
  },
  methods: {
    getOverviews() {
      this.$store.dispatch('i2SalesOverviewsReports/getOverviews')
    },
  },
}
</script>
